import { styled } from '@mui/material/styles'

export const Container = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;

  max-height: 69px;
  width: 100%;

  padding: ${({ theme }) => theme.spacing(3)} ${({ theme }) => theme.spacing(20)};
  background-color: #f4f4f4;

  ${props => props.theme.breakpoints.down('md')} {
    flex-direction: column-reverse;
    padding: ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(1)};
    max-height: fit-content;
  }
`
export const ProtexxaLogo = styled('div')`
  left: 10%;
  position: absolute;

  ${props => props.theme.breakpoints.down('md')} {
    left: 0;
    position: initial;
    margin-top: ${({ theme }) => theme.spacing(1)};
    padding-top: 5px;
    padding-bottom: 5px;
  }
`

export const StyledLink = styled('span')`
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
  cursor: pointer;
`

export const HiddenOnSmallScreen = styled('div')`
  ${props => props.theme.breakpoints.down('md')} {
    display: none;
  }
`

export const DisplayOnSmallScreen = styled('div')`
  display: none;

  ${props => props.theme.breakpoints.down('md')} {
    display: unset;
  }
`
